// hooks/useDeviceName.js
import { useState, useEffect } from "react";

const useDeviceName = () => {
  const [deviceName, setDeviceName] = useState("Unknown Device");

  useEffect(() => {
    const userAgent = navigator.userAgent;

    try{
      if (/android/i.test(userAgent)) {
        setDeviceName("Android Device (Mobile)");
      } else if (/iPad/.test(userAgent) || (navigator?.platform === 'MacIntel' && navigator?.maxTouchPoints > 1)) {
        setDeviceName("iPad (Tablet)");
      } else if (/iPhone|iPod/.test(userAgent) && !window.MSStream) {
        setDeviceName("iOS Device (Mobile)");
      } else if (/Windows NT/.test(userAgent) && /Mobile/.test(userAgent)) {
        setDeviceName("Windows Phone (Mobile)");
      } else if (/Windows NT/.test(userAgent)) {
        setDeviceName("Windows PC");
      } else if (/Macintosh/.test(userAgent) && /Mobile/.test(userAgent)) {
        setDeviceName("Mac (Mobile)");
      } else if (/Macintosh/.test(userAgent)) {
        setDeviceName("Mac");
      } else if (/Linux/.test(userAgent) && /Mobile/.test(userAgent)) {
        setDeviceName("Linux Device (Mobile)");
      } else if (/Linux/.test(userAgent)) {
        setDeviceName("Linux PC");
      } else {
        setDeviceName("Unknown Device");
      }
    }catch (e) {
      console.log(e)
    }

  }, []);

  return deviceName;
};

export const isMobileDevice = () => {
  const userAgent = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  const isTablet = /iPad|Kindle|Tablet|PlayBook|SM-T/i.test(userAgent);
  return isMobile && !isTablet;
};
export default useDeviceName;
